import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { applyVisualStyleStylesheet, readStoredVisualStyle } from './lib/designLanguage';
import App from './App';
import LandingPage from './LandingPage';

applyVisualStyleStylesheet(readStoredVisualStyle());

const path = window.location.pathname.replace(/\/+$/, '') || '/';
const shouldRenderApp = Capacitor.isNativePlatform() || path === '/app';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {shouldRenderApp ? <App /> : <LandingPage />}
  </React.StrictMode>
);

if (Capacitor.isNativePlatform()) {
  // Native app should never rely on browser SW cache; clear old registrations/caches from previous installs.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch(() => undefined);
  }
  if ('caches' in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => undefined);
  }
}

if (import.meta.env.PROD && 'serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
